import { useState, useEffect } from "react";
import s from "./Loader.module.css";

const Loader = () => {
    const [time, setTime] = useState(0);
    const [start] = useState(new Date());

    useEffect(() => {
        const updateTimer = () => {
            let delta = (new Date() - start) / 1000;
            setTime(delta);
        };
        const timerId = setInterval(updateTimer, 100);

        return () => {
            console.log("TIME", (new Date() - start) / 1000);
            clearInterval(timerId);
        };
    }, [start]);

    return (
        <div className={s.overlay}>
            <div className={s.spinner}>
                <div className={s.item}></div>
                <div className={s.item}></div>
                <div className={s.item}></div>
                <div className={s.item}></div>
                <div className={s.item}></div>
            </div>
            <p style={{ fontSize: "50px" }}>{time}</p>
        </div>
    );
};

export default Loader;
